import React from 'react'

function ShowDocumentTypes ({ doctypes }) {
  const filteredDocType = doctypes.filter(x => x.isImportant === 1)
  const docTypeToShow = filteredDocType.length > 0 ? filteredDocType : doctypes

  return (
    <>
      {(docTypeToShow && docTypeToShow.length > 0) ? (
        <>
          <strong>Document Type(s): </strong>
          {docTypeToShow.map(doctype => (<span key={doctype.id}>{doctype.name}</span>))
            .reduce((acc, x) => acc === null ? [x] : [acc, ', ', x], null)}
        </>
      ) : null}
    </>
  )
}

export default ShowDocumentTypes
